export const compressImage = (base64Str: string, callback: (compressedImage: string) => void) => {
    const img = new Image();
    img.src = base64Str;
    img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        const maxWidth = 800;
        const maxHeight = 800;
        let width = img.width;
        let height = img.height;

        if (width > height) {
            if (width > maxWidth) {
                height *= maxWidth / width;
                width = maxWidth;
            }
        } else {
            if (height > maxHeight) {
                width *= maxHeight / height;
                height = maxHeight;
            }
        }
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        const compressedBase64 = canvas.toDataURL('image/jpeg', 0.15);
        callback(compressedBase64);
    };
};


export const openImage = (base64Image: string) => {
    if (base64Image) {
        const newTab = window.open();
        if (newTab) {
        newTab.document.write(`
          <html>
            <head><title>Vista previa de la imagen</title></head>
            <body style="margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh;">
              <img src="${base64Image}" style="max-width: 100%; max-height: 100%;" />
            </body>
          </html>
        `);
      } else {
        alert("Permite las ventanas emergentes para ver la imagen.");
      }
    }
  };